/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  CustomChallenge
} from "../components/weeklyChallenges/customChallenge";
import { useParams } from "react-router-dom";
interface ICollapseState {
  [key: number]: boolean;
}
const ChallengeDetailsSideNav: React.FC<{
  allChallenges : CustomChallenge[];
  activeSlug: string;
  type?: string;
  onNavigationClick: (challenge: CustomChallenge) => void;
}> = ({ allChallenges, activeSlug, onNavigationClick, type }) => {
  const [collapse, setCollapse] = useState<ICollapseState>({});
  const [challenges, setChallenges] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [mobileNav, setMobileNav] = useState(false);
  const params = useParams();
  const toggleCollapse = (index: number) => {
    setCollapse((prevStates) => ({
      ...prevStates,
      [index]: !prevStates[index],
    }));
  };

  const onClickNav = (item: CustomChallenge)=>{
    onNavigationClick(item);
    setMobileNav(false);
  }

  useEffect(() => {
    if(allChallenges.length > 0){
    // 1. Group by year
    const groups = allChallenges.reduce((acc, challenge) => {
      const year = challenge.year; //? challenge.year : new Date(challenge.createdAt).getFullYear().toString();
      // make sure there’s an array for this year
      if (!acc[year]) acc[year] = [];
      acc[year].push(challenge);
      return acc;
    }, {} as Record<string, typeof challenges>);

    // 2. Turn that object into an array of { year, data } and sort descending
    const groupedArray = Object
    .entries(groups)           // [ ['2024', [ … ]], ['2025', [ … ]] ]
    .map(([year, data]) => ({ year, data }))
    .sort((a, b) => b.year.localeCompare(a.year));

    setChallenges(groupedArray);
    setIsLoading(false);
    }
  }, [allChallenges]);

  return (
    <div className={mobileNav ? `challengeLeftNav mobileActive` : 'challengeLeftNav' }>
      <div className="mobileNav" onClick={()=> {setMobileNav(!mobileNav)}}>Click to see the Challenges</div>
      <ul className="itemList">
      {
        challenges.map((item, index) => {
          
          return (

            <li className={collapse[index] ? '' : 'expandedItem'} key={index}>
                <button
                  aria-controls={`dropdown-authentication-${index}`} // Unique ID for each button
                  data-collapse-toggle={`dropdown-authentication-${index}`}
                  onClick={() => toggleCollapse(index)}
                >
                {item.year} {type === 'LOTW' ? 'Losers' : 'Season Challenges'}
                </button>
                <ul id={`dropdown-authentication-${index}`}>
                  {
                    item.data?.map((subItemName:any, subIndex:any) => {

                      return (
                        <>
                        <li key={`${index}-${subIndex}`} 
                            className={activeSlug === subItemName.slug ? 'active' : ''}
                            onClick={e => {
                              e.preventDefault();
                              onClickNav(subItemName)
                            }}
                        >
                          <span className="headingTxt">{subItemName.title}</span>
                          <span>Week {subItemName.week}</span>
                        </li>
                        </>
                      );

                    })
                  }
                </ul>
            </li>

          );
        
        })
      
      }
      </ul>
    </div>
  );
};

export default ChallengeDetailsSideNav;
